var map = {
	"./en/3-2/3_2-tit.png": 75615,
	"./fi/3-2/3_2-tit.png": 80769,
	"./in/3-2/3_2-tit.png": 38635,
	"./th/3-2/3_2-tit.png": 48822,
	"./tw/3-2/3_2-tit.png": 5525,
	"./zh/3-2/3_2-tit.png": 70048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82843;